import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ErrorPage from '../../Pages/Error';
import HomePage from '../../Pages/Home/Home';

const Routes = () => (
  <Switch>
    <Route path="/" component={HomePage} exact />
    <Route component={ErrorPage} />
  </Switch>
);

export default Routes;
